var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_c('ui-modal',{ref:"modal",attrs:{"title":'Editar Valor Recargo - ' + _vm.id,"transition":"scale-up","size":"large"},on:{"close":function($event){return _vm.closeModalEvent()}}},[_c('recargos-form',{attrs:{"closeModal":_vm.cerrarModal,"showReset":false,"id":_vm.id,"action":'update'}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }